import api, { v1 } from "../../repositories/API/Axios.api";
import { CatalogItem } from "./interface/CatalogItem";

export const getFieldsCatalog = async (route: string) => {
  const response: any = await api
    .get<CatalogItem[]>(v1(route))
    .catch((error) => console.log(error));
  return response?.data;
};
